import { page, shows, type FeatureRoutes } from "@/app/feature";

export const routes: FeatureRoutes = {
  shell: [
    {
      path: "settings",
      lazy: page(() => import("./SettingsPage")),
      handle: shows("settings"),
    },
    {
      path: "settings/sign-in",
      lazy: page(() => import("./SignInMethodsPage")),
      handle: shows("auth"),
    },
    {
      path: "settings/notifications",
      lazy: page(() => import("./NotificationSettingsPage")),
      handle: shows("notifications"),
    },
  ],
};
